import React, { useMemo } from "react";
import { Card, Box, Typography, Stack } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import MDTypography from "components/MDTypography";

// Register required Chart.js components
Chart.register(ArcElement, Tooltip, Legend);

const ActivePieCard = ({
  chart,
  darkMode }) => {

  // const datas = chart?.datasets?.[0]?.data || [];
  // const total = datas?.[0] + datas?.[1] || 0;
  // const inUse = datas?.[0] || 0;
  // const available = datas?.[1] || 0;

  const STATUS_COLORS = {
    Available: "#b7eb8f",
    Charging: "#91caff",
    SuspendedEV: "#FFD54F",
    SuspendedEVSE: "#FFB74D",
    Unavailable: "#E57373",
    Faulted: "#D32F2F",
    Reserved: "#BA68C8",
    Inactive: "#aab6bd",
  };


  // Chart data

  const statusEntries = useMemo(() => {
    if (!chart) return [];

    return Object.entries(chart)
      .filter(([_, value]) => Number(value) > 0); // hide zero values
  }, [chart]);

  const labels = statusEntries.map(([key]) => key);
  const values = statusEntries.map(([_, value]) => value);
  const total = values.reduce((a, b) => a + b, 0);

  const chartData = useMemo(() => ({
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: labels.map(
          (label) => STATUS_COLORS[label] || "#BDBDBD"
        ),
        hoverBackgroundColor: labels.map(
          (label) => STATUS_COLORS[label] || "#9E9E9E"
        ),
        borderWidth: 0,
      },
    ],
  }), [labels, values]);

  // Chart options
  const chartOptions = useMemo(() => ({
    responsive: true,
    cutout: "70%",
    animation: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        position: "nearest",
        yAlign: "bottom",
        xAlign: "center",
        padding: 10,
      },
    },
  }), []);
  return (
    <Card
      sx={{
        width: {
          xs: "100%"
        },
        height: "100%",
        display: "flex",
        p: 2,
        borderRadius: 3,
        textAlign: "center",
        justifyContent: "space-between"
      }}
    >
      <MDTypography variant="h5" fontWeight="medium" textAlign="start" ml={1}>
        Active Charge Points
        <br />
        <br />

      </MDTypography>

      {/* Doughnut Chart */}
      <Box sx={{ position: "relative", my: 1, mx: 8 }}>
        <Doughnut data={chartData} options={chartOptions} />
        {/* Centered Total Count */}
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
          }}
        >
          Total <br /> {total}
        </Typography>

      </Box>

      {/* Legend Section */}
      <Stack spacing={0.8} my={1}>
        {statusEntries.map(([status, value]) => (
          <Box
            key={status}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  bgcolor: STATUS_COLORS[status] || "#BDBDBD",
                  borderRadius: "2px",
                  mr: 1,
                }}
              />
              <Typography
                variant="body2"
                sx={{ color: darkMode ? "white" : "black" }}
              >
                {status}
              </Typography>
            </Box>

            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{ color: darkMode ? "white" : "black" }}
            >
              {value}
            </Typography>
          </Box>
        ))}
      </Stack>

    </Card>
  );
};

export default React.memo(ActivePieCard);
